import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Select from "react-select";
import CabecalhoAdmin from "../../../componentes/CabecalhoAdmin";
import MenuLateral from "../../../componentes/MenuLateral";
import Pesquisa from "../../../componentes/Pesquisa";
import Botao from "../../../componentes/Botao";
import ErroSpan from "../../../componentes/ErroSpan";
import CupomImagem from "./CupomImagem";
import { criarCupons, obterCupons } from "../../../servicos/cuponsServices";
import { TabelaCupons } from "./TabelaCupons";
import { AreaSuperior, FiltrarData, InputMes, LinksPaginas, OpcoesFiltragem, PaginasTabela, RodapePaginas, SecaoAdmin, SecaoPrincipal, TotalDocs } from "../AdminStyled";
import { ContainerModalAdicionar, DivAdicionar, DivBotoes } from "./CuponsStyled"

export default function Cupons() {
    const [params, setParams] = useSearchParams();
    const cupomRef = useRef(null);
    const [cupons, setCupons] = useState([]);
    const [cupomSelecionado, setCupomSelecionado] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const [mensagem, setMensagem] = useState({ mostrar: false, texto: "", erro: false })
    const [busca, setBusca] = useState("");
    const [total, setTotal] = useState({ paginas: 1, docs: 0 });
    const [mostraModal, setMostraModal] = useState(false);
    const [quantidade, setQuantidade] = useState(1);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");

    const opcoesOrigem = [
        { value: "site", label: "Site" },
        { value: "admin", label: "Admin site" },
        { value: "tour", label: "Admin tour" },
        { value: "parksnet", label: "PARKSNET" }
    ];

    // Carregamento dos cupons
    useEffect(() => {
        setCarregando(true);
        obterCupons(params.get("pagina"), params.get("ordenacao"), params.get("ordem"), params.get("busca"), params.get("dataInicial"), params.get("dataFinal"), params.get("origem")).then(resposta => {
            if (resposta && resposta.cupons) {
                setCarregando(false);
                setCupons(resposta.cupons);
                setTotal({ paginas: resposta.totalPaginas, docs: resposta.totalDocs });
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.get("pagina"), params.get("ordenacao"), params.get("ordem"), params.get("busca"), params.get("dataInicial"), params.get("dataFinal"), params.get("origem")]);

    // Atualiza a busa nos parametros da URL
    useEffect(() => {
        atualizarParametro("busca", busca);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [busca]);

    // Função para atualizar um parametro da URL
    function atualizarParametro(parametro, valor) {
        if (!valor) valor = "";

        setParams(params => {
            params.set(parametro, valor);
            return params;
        });

        setMensagem({ erro: false, mostrar: false, texto: "" });
    }

    // Função para retornar um json válido para o select de origem de acordo com uma string
    function obterValorSelect(origem) {
        if (!origem) return { value: "", label: "" }
        return opcoesOrigem.find(e => e.value === origem);
    }

    // Função para adicionar novos cupons
    function criarNovosCupons() {
        criarCupons(quantidade, nome, email, null).then( resposta => {
            if (resposta) {
                atualizarParametro("dataInicial", new Date().toISOString().slice(0, 10));
                atualizarParametro("dataFinal", new Date().toISOString().slice(0, 10));
                atualizarParametro("origem", "tour");
                atualizarParametro("pagina", "1");
                setMostraModal(false);
                setMensagem({ erro: false, mostrar: true, texto: `Foram criados ${quantidade} cupons!` });
            } else {
                setMostraModal(false);
                setMensagem({ erro: true, mostrar: true, texto: "Erro ao criar cupons" });
            }
        });
    }

    return (<SecaoAdmin>
        <ContainerModalAdicionar $mostrar={mostraModal}>
            <DivAdicionar>
                <p style={{ marginTop: "15px" }}>Informe a quantidade de cupons que deseja criar:</p>
                <input style={{ marginLeft: "10px", fontSize: "14px" }} type="number" min={1} value={quantidade} onChange={e => setQuantidade(e.target.value)} />
                <p style={{ marginTop: "15px" }}>Nome:</p>
                <input style={{ marginLeft: "10px", fontSize: "14px" }} value={nome} onChange={e => setNome(e.target.value)} />
                <p style={{ marginTop: "15px" }}>E-mail:</p>
                <input style={{ marginLeft: "10px", fontSize: "14px" }} value={email} onChange={e => setEmail(e.target.value)} />
                <DivBotoes>
                    <Botao onClick={() => criarNovosCupons()}>Ok</Botao>
                    <Botao onClick={() => setMostraModal(false)}>Cancelar</Botao>
                </DivBotoes>
            </DivAdicionar>
        </ContainerModalAdicionar>
        <MenuLateral />
        <SecaoPrincipal>
            {CabecalhoAdmin("Cupons")}
            {mensagem.mostrar && <ErroSpan $corFundo={mensagem.erro ? "#ffcdcd" : "#d1ffcd"} $corTexto={mensagem.erro ? "#9e0000" : "#059e00"}>{mensagem.texto}</ErroSpan>}
            <AreaSuperior>
                <OpcoesFiltragem>
                    <FiltrarData $marginTop="1px">
                        <label>Data inicial</label>
                        <InputMes type="date" value={params.get("dataInicial")} onChange={event => atualizarParametro("dataInicial", event.target.value)} />
                    </FiltrarData>
                    <FiltrarData $marginTop="1px">
                        <label>Data final</label>
                        <InputMes type="date" value={params.get("dataFinal")} onChange={event => atualizarParametro("dataFinal", event.target.value)} />
                    </FiltrarData>
                    <FiltrarData>
                        <label>Origem</label>
                        <Select
                            options={opcoesOrigem}
                            isClearable="false"
                            placeholder="Origem"
                            value={obterValorSelect(params.get("origem"))}
                            onChange={e => atualizarParametro("origem", e?.value)}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderRadius: "2px",
                                    border: "1px solid #252525",
                                    width: "200px",
                                    height: "31px",
                                    minHeight: '30px',
                                    fontSize: "14px",
                                    borderColor: state.hover ? 'black' : 'rgba(58, 23, 14, 0.308)'
                                }),
                                input: (provided, state) => ({
                                    ...provided,
                                    margin: '0px',
                                }),
                                valueContainer: (provided, state) => ({
                                    ...provided,
                                    height: '30px',
                                    padding: '0 6px'
                                }),
                                indicatorsContainer: (provided, state) => ({
                                    ...provided,
                                    height: '30px',
                                }),
                                option: (baseStyles) => ({
                                    ...baseStyles,
                                    color: "black"
                                })
                            }}
                        />
                    </FiltrarData>
                </OpcoesFiltragem>
                {Pesquisa(setBusca, null, busca)}
            </AreaSuperior>
            <AreaSuperior>
                <Botao onClick={() => setMostraModal(true)}>Adicionar cupons</Botao>
            </AreaSuperior>
            {carregando && <ErroSpan $corFundo="transparent" $corTexto="#252525">Carregando...</ErroSpan>}
            {TabelaCupons(cupons, params.get("ordenacao"), params.get("ordem"), atualizarParametro, cupomRef, setCupomSelecionado)}
            <RodapePaginas>
                <TotalDocs>
                    <p>Total: {total.docs}</p>
                </TotalDocs>
                <PaginasTabela>
                    <p onClick={() => atualizarParametro("pagina", 1)}>Primeira</p>
                    <p onClick={() => {
                        if (params.get("pagina") > 1) atualizarParametro("pagina", Number(params.get("pagina")) - 1);
                    }
                    }>Anterior</p>
                    {paginas()}
                    <p onClick={() => {
                        if (params.get("pagina") < total.paginas) atualizarParametro("pagina", Number(params.get("pagina")) + 1);
                    }}>Próxima</p>
                    <p onClick={() => atualizarParametro("pagina", total.paginas)}>Última</p>
                </PaginasTabela>
            </RodapePaginas>
        </SecaoPrincipal>
        {cupomSelecionado && (
            <CupomImagem
                ref={cupomRef}
                codigo={cupomSelecionado.codigo}
                validade={cupomSelecionado.validade}
            />
        )}
    </SecaoAdmin>)

    function paginas() {
        let pages = [];
        let ajuste = 2;
        if (Number(params.get("pagina")) === 1) {
            ajuste = 0;
        } else if (Number(params.get("pagina")) === 2) {
            ajuste = 1;
        } else if (Number(params.get("pagina")) === total.paginas - 1 && total.paginas > 4) {
            ajuste = 3;
        } else if (Number(params.get("pagina")) === total.paginas && total.paginas > 4) {
            ajuste = 4;
        }
        if (total.paginas < 5) {
            for (let i = 0; i < total.paginas; i++) {
                let pageNum = parseInt(i + 1);

                if (pageNum === Number(params.get("pagina"))) {
                    pages.push(<LinksPaginas key={`page${pageNum}`} $corFundo="var(--corNugaliEscura)" $cor="white">{pageNum}</LinksPaginas>)
                } else {
                    pages.push(<LinksPaginas
                        key={`page${pageNum}`}
                        id={pageNum}
                        onClick={event => atualizarParametro("pagina", parseInt(event.currentTarget.id))
                        }>
                        {pageNum}
                    </LinksPaginas>)
                }
            }
        } else {
            for (let i = 0; i < 5; i++) {
                let pageNum = parseInt(params.get("pagina")) + parseInt(i) - ajuste;
                if (pageNum === Number(params.get("pagina"))) {
                    pages.push(<LinksPaginas key={`page${pageNum}`} $corFundo="var(--corNugaliEscura)" $cor="white">{pageNum}</LinksPaginas>)
                } else {
                    pages.push(<LinksPaginas
                        key={`page${pageNum}`}
                        id={pageNum}
                        onClick={event => atualizarParametro("pagina", parseInt(event.currentTarget.id))
                        }>
                        {pageNum}
                    </LinksPaginas>)
                }
            }
        }
        return pages;
    }
}

